/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableData } from '@/components/Table/types';
import { formatDateAndTime } from './formatDate';

const DEFAULT_FILE_NAME = 'Montecon';

const saveAsExcelFile = (buffer: any, fileName: string) => {
  import('file-saver').then((module) => {
    if (module && module.default) {
      const EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const EXCEL_EXTENSION = '.xlsx';
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });

      module.default.saveAs(data, `${fileName}${EXCEL_EXTENSION}`);
    }
  });
};

type ExportExcelArgs = {
  data: TableData;
  fileName?: string;
  selectedColumns?: string[];
};

const formatColumnTitle = (title: string): string => {
  return title
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .replace(/ ([A-Z])/g, (str) => str.toLowerCase());
};

export const exportExcel = ({
  data,
  fileName = DEFAULT_FILE_NAME,
  selectedColumns,
}: ExportExcelArgs) => {
  import('xlsx').then((xlsx) => {
    const columns =
      selectedColumns || (data.length > 0 ? Object.keys(data[0]) : []);
    const formattedColumns = columns.map(formatColumnTitle);

    const filteredData = data.map((row) =>
      formattedColumns.reduce((acc, columnName, index) => {
        const originalColumnName = columns[index];
        let value = row[originalColumnName];
        if (value instanceof Date) {
          value = formatDateAndTime(value.toISOString());
        }
        acc[columnName] = value ?? '';
        return acc;
      }, {} as any)
    );

    const worksheet = xlsx.utils.json_to_sheet(filteredData);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer = xlsx.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    saveAsExcelFile(excelBuffer, fileName);
  });
};
